import styled from 'styled-components/macro';
import { device } from '../../device';


export const StyledMapKey = styled.div`
    display:flex;
    flex-wrap:wrap;
    flex-direction:column;

    @media ${device.tablet} { 
        flex-direction:row;
        justify-content:space-between;
    }
`;

export const Highlight = styled.span`
    color:${ props => props.color };
    font-weight:bold;
`;

export const Overview = styled.div`
    width:100%;
    padding-bottom:20px;
    text-align:center;

    @media ${device.tablet} { 
        width:auto;
    }
`;



export const Legend = styled.div`
    display:flex;
    justify-content:center;
    flex-wrap:wrap;
    width:100%;

    @media ${device.tablet} { 
        text-align:right;
        /* flex-direction:column; */
    }
`;

export const LegendItem = styled.div`
    text-decoration:none;
    font-size: 1.06rem;
    color: #8B8B8B;
    margin-right:15px;
    @media ${device.tablet} { 
        font-size:1.25rem;
    }
`;

export const LegendIcon = styled.img`
    padding-right:15px;
    max-width:100%;
    height:auto;
`;